export default "__VITE_ASSET__NPPgu22I__"